import { render, staticRenderFns } from "./GffTabs.vue?vue&type=template&id=4945d75f"
import script from "./GffTabs.vue?vue&type=script&lang=js"
export * from "./GffTabs.vue?vue&type=script&lang=js"
import style0 from "./GffTabs.vue?vue&type=style&index=0&id=4945d75f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports